import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Spinner, ListGroupItem, Card, Container } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { fetchCategories } from "store/actions/categoriesActions";
import Items from "./Items";

function Categories({ searchQuery }) {
  const dispatch = useDispatch();

  const { user, userPermissions } = useSelector((state) => state.auth);
  const { categories } = useSelector((state) => state.category);
  const [activeIndex, setActiveIndex] = useState(null);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const { restaurantsDetail } = useSelector((state) => state.restaurant);
  const categoryRefs = useRef([]);
  const scrollTargetIndex = useRef(null);

  const queryParams =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search)
      : new URLSearchParams();
  const menuID = queryParams.get("menu");

  const handleToggle = (index) => {
    setActiveIndex((prev) => {
      const isNew = prev !== index;
      if (isNew) {
        scrollTargetIndex.current = index;
      } else {
        scrollTargetIndex.current = null;
      }
      return isNew ? index : null;
    });
  };

  useEffect(() => {
    const index = scrollTargetIndex.current;

    if (index !== null) {
      setTimeout(() => {
        const el = categoryRefs.current[index];
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top, behavior: "smooth" });
          scrollTargetIndex.current = null;
        }
      }, 100);
    }
  }, [activeIndex]);

  useEffect(() => {
    setLoadingCategories(true);
    dispatch(fetchCategories(user?.restaurantID, menuID)).finally(() =>
      setLoadingCategories(false)
    );
  }, [dispatch, menuID, user?.restaurantID]);

  return (
    <Container className="w-full mt-4 mb-4" fluid>
      {loadingCategories ? (
        <div className="d-flex justify-content-center align-items-center py-5">
          <Spinner size="md" color="danger" />
        </div>
      ) : categories.filter((category) => category.hasItems)?.length > 0 ? (
        categories
          .filter(
            (category) =>
              category.hasItems &&
              (!searchQuery ||
                category.name.toLowerCase().includes(searchQuery.toLowerCase()))
          )
          .map((category, index) => (
            <div
              key={category.id}
              className="w-full mb-1 rounded-top overflow-hidden"
              ref={(el) => {
                categoryRefs.current[index] = el;
              }}
            >
              <ListGroupItem
                className="w-100 max-h-[42px] py-2"
                style={{ backgroundColor: restaurantsDetail?.adminColor }}
                tag="button"
                onClick={() => handleToggle(index)}
              >
                <Row className="justify-content-between align-items-center">
                  <Col xs="10" className="text-left">
                    <span className="mr-2 text-white">
                      {`${index + 1}. `}
                      {searchQuery
                        ? category?.name
                            .split(new RegExp(`(${searchQuery})`, "gi"))
                            .map((part, i) =>
                              part.toLowerCase() ===
                              searchQuery.toLowerCase() ? (
                                <mark key={i}>{part}</mark>
                              ) : (
                                <span key={i}>{part}</span>
                              )
                            )
                        : category?.name}
                    </span>
                  </Col>

                  <Col className="text-right">
                    <i
                      className={`fas ${
                        activeIndex === index
                          ? "fa-angle-down"
                          : "fa-angle-right"
                      } text-white`}
                    />
                  </Col>
                </Row>
              </ListGroupItem>

              {activeIndex === index && (
                <Card
                  className="mt-1 border border-lighter"
                  style={{
                    borderRadius: "0.5rem",
                  }}
                >
                  {user?.type === "kitchen-waiter" &&
                  userPermissions?.menus?.category?.items?.active ? (
                    <Items categoryId={category.id} />
                  ) : (
                    <Row className="py-4 justify-content-center align-items-center">
                      You don't have permission to access the items of this
                      category
                    </Row>
                  )}
                </Card>
              )}
            </div>
          ))
      ) : (
        <div className="d-flex justify-content-center align-items-center py-5 text-danger">
          No Categories found for this Menu
        </div>
      )}
    </Container>
  );
}

export default Categories;
